import { useMutation, useQueryClient } from '@tanstack/react-query';
import { retentionAdminApi } from '../api/retentionAdminApi';
import type { PurgeRequest } from '../types/retentionAdmin';

/**
 * POST /api/eraf/retention-admin/policies/{id}/purge — 물리 삭제 (RETENTION_PURGE)
 * 2단계 확인 필수: dryRunToken + confirmName
 */
export function usePurge() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: PurgeRequest }) =>
      retentionAdminApi.purge(id, body),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: ['retention-admin', 'list'] });
      void qc.invalidateQueries({ queryKey: ['retention-admin', 'detail', vars.id] });
      void qc.invalidateQueries({ queryKey: ['retention-admin', 'runs'] });
    },
  });
}
